import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { Lookup } from '../Lookup';
/**
 * FormLookup.
 *
 * Disabled by default if `isSubmitting` is **true**.
 */
const FormLookup = ({ items, keyField, labelField, isLoading, onBeforeChange, ...useControllerProps }) => {
    const { field: { value, disabled, onChange }, 
    // fieldState: { invalid, error },
    formState: { isSubmitting }, } = useController(useControllerProps);
    const handleLookupChange = (event) => {
        onBeforeChange?.();
        onChange(event);
    };
    return (_jsx(Lookup, { items: items, isLoading: isLoading, keyField: keyField, labelField: labelField, value: value, disabled: isSubmitting || disabled, onChange: handleLookupChange }));
};
export { FormLookup };
